export default class Club {
    static fromData(data) {
        if (!data) {
            return;
        }

        const club = new Club();
        club.id = data.id;
        club.feeDistributionEnabled = data.feeDistributionEnabled;
        club.sepaBankAccountId = data.sepaBankAccountId;
        club.email2 = data.email2;
        club.invoicingStart = data.invoicingStart;

        Object.seal(club);
        return club;
    }
}
